export const exportVouchersCSV = (rows, filename = defaultCsvName()) => {
  if (!Array.isArray(rows) || rows.length === 0) {
    alert('Nothing to export.');
    return;
  }

  // Choose columns & headers (order matters)
  const columns = [
    { key: 'id',          header: 'ID' },
    { key: 'code',        header: 'Voucher Code' },
    { key: 'plan_id',     header: 'Plan ID' },
    { key: 'plan_name',   header: 'Plan' },
    { key: 'source',      header: 'Source' },
    { key: 'msisdn',      header: 'MSISDN' },
    { key: 'created_by',  header: 'Created By' },
    { key: 'status',      header: 'Status' },
    { key: 'created_at',  header: 'Created At' },
    { key: 'expires_at',  header: 'Expires At' },
    { key: 'usage_count', header: 'Usage Count' },
    { key: 'amount',      header: 'Amount (UGX)' },
  ];

  const esc = (value) => {
    // Null/undefined -> empty
    let v = value ?? '';
    // Convert non-strings safely
    if (v instanceof Date) v = v.toISOString();
    else if (typeof v !== 'string') v = String(v);

    // Prevent CSV/Excel formula injection
    if (/^[=+\-@]/.test(v)) v = "'" + v;

    // Quote + escape quotes
    v = v.replace(/"/g, '""');
    return `"${v}"`;
  };

  const headerLine = columns.map(c => esc(c.header)).join(',');
  const lines = rows.map(row =>
    columns.map(c => esc(row[c.key])).join(',')
  );

  // BOM helps Excel open UTF-8 correctly
  const csv = '\uFEFF' + [headerLine, ...lines].join('\r\n');

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  URL.revokeObjectURL(url);
  a.remove();
}

const defaultCsvName = (prefix = 'vouchers') => {
  const pad = (n) => String(n).padStart(2, '0');
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = pad(d.getMonth() + 1);
  const dd = pad(d.getDate());
  const hh = pad(d.getHours());
  const mi = pad(d.getMinutes());
  const ss = pad(d.getSeconds());
  return `${prefix}_${yyyy}${mm}${dd}_${hh}${mi}${ss}.csv`;
}
